class DesktopMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.firstLevelItems = this.querySelectorAll('li[data-first-level]');
        this.secondLevelItems = this.querySelectorAll('li[data-second-level]');

        this.firstLevelItems.forEach(li => {
            li.addEventListener('click', (e) => this.toggleSecondLevel(e));
        });

        this.secondLevelItems.forEach(li => {
            li.addEventListener('click', (e) => this.toggleThirdLevel(e));
        });
    }

    toggleSecondLevel(event) {
        const li = event.currentTarget;
        const parentId = li.dataset.id;

        // Trova il secondo livello relativo
        const currentSecondLevel = this.querySelector(`ul[data-parent='${parentId}']`);
        const secondLevelLists = this.querySelectorAll(`ul[data-parent]`);

        // Mostra solo il menu cliccato, nasconde gli altri
        secondLevelLists.forEach(ul => {
            if (ul === currentSecondLevel) {
                ul.classList.remove('tw-hidden'); // mostra sempre il menu cliccato
            } else if (ul.dataset.parent.startsWith('lvl1-')) {
                ul.classList.add('tw-hidden'); // nasconde gli altri
            }
        });

        // Aggiorna active/inactive primo livello
        this.firstLevelItems.forEach(fli => fli.dataset.firstLevel = 'inactive');
        li.dataset.firstLevel = 'active';

        // Nascondi tutti i terzi livelli
        const thirdLevelLists = this.querySelectorAll(`ul[data-parent][data-parent*="-child"]`);
        thirdLevelLists.forEach(ul => ul.classList.add('tw-hidden'));
        this.secondLevelItems.forEach(sli => sli.dataset.secondLevel = 'inactive');

        // LOGICA IMMAGINI PRIMO LIVELLO
        const allImages = this.querySelectorAll('.menu-image');
        allImages.forEach(img => img.classList.add('tw-hidden'));

        const activeImage = this.querySelector(`.menu-image[data-id='${parentId}']`);
        if (activeImage) activeImage.classList.remove('tw-hidden');
    }


    toggleThirdLevel(event) {
        const li = event.currentTarget;
        const parentId = li.dataset.parent; // parent del secondo livello
        const childId = li.dataset.id;      // id del terzo livello

        // Trova il terzo livello relativo
        const currentThirdLevel = this.querySelector(`ul[data-parent='${childId}']`);
        const allThirdLevelLists = this.querySelectorAll(`ul[data-parent][data-parent*="-child"]`);

        if (currentThirdLevel) {
            // Mostra il terzo livello cliccato, nasconde tutti gli altri
            allThirdLevelLists.forEach(ul => {
                if (ul === currentThirdLevel) {
                    ul.classList.remove('tw-hidden'); // sempre visibile
                } else {
                    ul.classList.add('tw-hidden'); // nasconde gli altri
                }
            });
        } else {
            // Se non c'è un figlio, nasconde tutti i terzi livelli
            allThirdLevelLists.forEach(ul => ul.classList.add('tw-hidden'));
        }

        // Aggiorna active/inactive solo del secondo livello
        this.secondLevelItems.forEach(sli => {
            if (sli.dataset.parent === parentId) {
                sli.dataset.secondLevel = 'inactive';
            }
        });
        li.dataset.secondLevel = 'active';

        // -----------------------------
        // LOGICA PER LE IMMAGINI SECONDO LIVELLO
        const allImages = this.querySelectorAll('.menu-image');
        allImages.forEach(img => img.classList.add('tw-hidden'));

        const activeImage = this.querySelector(`.menu-image[data-id='${childId}']`);
        if (activeImage) activeImage.classList.remove('tw-hidden');
        // -----------------------------
    }

    resetNavigation() {
        this.querySelectorAll('ul[data-parent]').forEach(ul => ul.classList.add('tw-hidden'));
        this.secondLevelItems.forEach(sli => sli.dataset.secondLevel = 'inactive');
        this.querySelectorAll('.menu-image').forEach(img => img.classList.add('tw-hidden'));
        this.firstLevelItems.forEach(fli => fli.dataset.firstLevel = 'active');
    }

}

customElements.define('desktop-menu', DesktopMenu);



class MobileMenu extends HTMLElement {
    constructor() {
        super();
        this.state = {
            currentSubmenu: null,
        };
    }

    connectedCallback() {
        // elementi principali (sa-mobile-menu: [data-menu-main]; mobile-menu.liquid Broadcast può non averlo)
        this.mainMenu = this.querySelector('[data-menu-main]');
        this.submenuPanels = Array.from(this.querySelectorAll('.submenu-panel'));

        if (!this.mainMenu) {
            return;
        }

        // li del main menu (trigger)
        this.firstLevelTriggers = Array.from(this.querySelectorAll('[data-submenu-trigger]'));

        // mappa trigger -> parentId (assume ordine 1..N corrispondente a lvl1-1, lvl1-2, ...)
        this.firstLevelTriggers.forEach((el, idx) => {
            el.dataset.parentId = `lvl1-${idx + 1}`;
        });

        // delegation click: apre submenu e gestisce back
        this.addEventListener('click', (e) => {
            // click su trigger primo livello
            const submenuTrigger = e.target.closest('[data-submenu-trigger]');
            if (submenuTrigger) {
                e.preventDefault();
                const submenuName = submenuTrigger.dataset.submenuTrigger;
                const parentId = submenuTrigger.dataset.parentId;
                this.openSubmenu(submenuName, parentId);
                return;
            }

            // click sul pulsante back del submenu
            const backBtn = e.target.closest('.submenu-back');
            if (backBtn) {
                e.preventDefault();
                this.closeSubmenu();
                return;
            }

            // click su second-level item (apre il terzo livello)
            const secondLevelLi = e.target.closest('li[data-second-level]');
            if (secondLevelLi) {
                this.toggleThirdLevel(secondLevelLi);
                return;
            }
        });

        // inizialmente: assicurati che tutti i panels siano a posto
        this.submenuPanels.forEach(panel => {
            panel.classList.add('tw-translate-x-full');
            panel.classList.add('tw-hidden'); // li lasci hidden come nel markup
            panel.setAttribute('aria-hidden', 'true');
        });

        // main menu iniziale
        this.mainMenu.classList.remove('-tw-translate-x-full');
        this.mainMenu.classList.add('tw-translate-x-0');
    }

    // APRE il submenu (name = data-submenu-panel, parentId = lvl1-X)
    openSubmenu(submenuName, parentId) {
        if (!this.mainMenu) return;
        const submenu = this.querySelector(`[data-submenu-panel="${submenuName}"]`);
        if (!submenu) return;

        // nascondi/chiudi tutti i pannelli prima di aprire il corretto
        this.submenuPanels.forEach(panel => {
            if (panel !== submenu) {
                panel.classList.add('tw-translate-x-full');
                panel.classList.remove('tw-translate-x-0');
                panel.classList.add('tw-hidden');
                panel.setAttribute('aria-hidden', 'true');
            }
        });

        // mostra il pannello target
        submenu.classList.remove('tw-hidden');
        // forza reflow se vuoi sicurezza nella transizione
        void submenu.offsetWidth;
        submenu.classList.remove('tw-translate-x-full');
        submenu.classList.add('tw-translate-x-0');
        submenu.setAttribute('aria-hidden', 'false');

        // sposta il main menu a sinistra
        this.mainMenu.classList.add('-tw-translate-x-full');

        // memorizza stato
        this.state.currentSubmenu = { panel: submenu, parentId };

        // mostra i second-level corretti all'interno del panel
        this._showSecondLevelInPanel(submenu, parentId);
    }

    // mostra solo gli <ul data-parent="parentId"> dentro il panel
    _showSecondLevelInPanel(panel, parentId) {
        // trova tutte le liste data-parent all'interno del panel
        const lists = Array.from(panel.querySelectorAll('ul[data-parent]'));

        lists.forEach(ul => {
            if (ul.dataset.parent === parentId) {
                ul.classList.remove('tw-hidden');
            } else {
                ul.classList.add('tw-hidden');
            }
        });

        // nascondi tutti i terzi livelli dentro il panel (preparazione)
        const thirdLists = Array.from(panel.querySelectorAll('ul[data-parent][data-parent*="-child"]'));
        thirdLists.forEach(tl => tl.classList.add('tw-hidden'));

        // reset second-level active states
        const secondLis = Array.from(panel.querySelectorAll('li[data-second-level]'));
        secondLis.forEach(li => li.dataset.secondLevel = 'inactive');
    }

    // CHIUDE il submenu corrente (ritorna al main)
    closeSubmenu() {
        if (!this.mainMenu || !this.state.currentSubmenu) return;

        const { panel } = this.state.currentSubmenu;

        // anima il panel fuori e poi nascondilo
        panel.classList.remove('tw-translate-x-0');
        panel.classList.add('tw-translate-x-full');
        panel.setAttribute('aria-hidden', 'true');

        // dopo durata transizione nascondi per evitare sovrapposizioni
        setTimeout(() => {
            panel.classList.add('tw-hidden');
        }, 300); // allineare alla tua tw-duration-300

        // riporta main menu al centro
        this.mainMenu.classList.remove('-tw-translate-x-full');
        this.mainMenu.classList.add('tw-translate-x-0');

        this.state.currentSubmenu = null;
    }

    // toggle per il terzo livello: mostra solo il relativo ul[data-parent=childId]
    toggleThirdLevel(li) {
        // li ha data-id (childId) e data-parent (parentId)
        const childId = li.dataset.id;
        const parentId = li.dataset.parent;

        // trova pannello corrente (se non c'è, non fare nulla)
        if (!this.state.currentSubmenu) return;
        const panel = this.state.currentSubmenu.panel;

        // trova tutte le terze liste nel panel
        const allThird = Array.from(panel.querySelectorAll('ul[data-parent][data-parent*="-child"]'));

        if (!childId) {
            // nessun id, quindi nasconde tutte
            allThird.forEach(ul => ul.classList.add('tw-hidden'));
            this.secondLevelItemsInPanel(panel).forEach(sli => sli.dataset.secondLevel = 'inactive');
            return;
        }

        // trova quella relativa al childId
        const target = panel.querySelector(`ul[data-parent='${childId}']`);

        // nasconde tutte le altre terze liste
        allThird.forEach(ul => {
            if (ul === target) {
                ul.classList.remove('tw-hidden');
            } else {
                ul.classList.add('tw-hidden');
            }
        });

        // aggiorna active state tra second-level dentro il panel
        this.secondLevelItemsInPanel(panel).forEach(sli => {
            sli.dataset.secondLevel = (sli.dataset.id === childId) ? 'active' : 'inactive';
        });
    }

    // helper: tutti i second-level <li> dentro un panel
    secondLevelItemsInPanel(panel) {
        return Array.from(panel.querySelectorAll('li[data-second-level]'));
    }

    resetNavigation() {
        if (!this.mainMenu) return;

        if (this.state.currentSubmenu) {
            const { panel } = this.state.currentSubmenu;
            panel.classList.remove('tw-translate-x-0');
            panel.classList.add('tw-translate-x-full', 'tw-hidden');
            panel.setAttribute('aria-hidden', 'true');
        }
        this.mainMenu.classList.remove('-tw-translate-x-full');
        this.mainMenu.classList.add('tw-translate-x-0');
        this.state.currentSubmenu = null;

        this.submenuPanels.forEach(panel => {
            const thirdLists = Array.from(panel.querySelectorAll('ul[data-parent][data-parent*="-child"]'));
            thirdLists.forEach(tl => tl.classList.add('tw-hidden'));
            this.secondLevelItemsInPanel(panel).forEach(li => li.dataset.secondLevel = 'inactive');
        });
    }
}

customElements.define('mobile-menu', MobileMenu);
